module.exports = __webpack_public_path__ + "static/img/319_TO8_2486.ca7a4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/319_TO8_2486.jpg
// module id = xtUP
// module chunks = 0